import React, { useState } from "react";
import "./RCPro.css";

const RCPro = () => {
  const [rcno, setRcno] = useState("");
  const [data, setData] = useState(null);
  const [pdf, setPdf] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 🔍 SEARCH FUNCTION
  const searchRC = async () => {
    if (!rcno) {
      setError("Please enter RC Number");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      alert("Please login first");
      return;
    }

    setLoading(true);
    setError("");
    setData(null);

    try {
      const res = await fetch(
        "https://rcfinder.online/api/rcpro.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: user.id,
            rcno: rcno,
          }),
        }
      );

      const result = await res.json();

      // 💰 Wallet low
      if (result.status === "wallet_low") {
        setError("Balance low, please recharge");
        setLoading(false);
        return;
      }

      // ✅ Success
      if (result.status) {
        setData(result.data);
        setPdf(result.pdf);

        // 👉 optional: wallet update UI me reflect karna
        if (user.wallet_balance) {
          user.wallet_balance -= 100;
          localStorage.setItem("user", JSON.stringify(user));
        }
      } else {
        setError(result.message || "No data found");
      }

    } catch (err) {
      setError("Server error");
    }

    setLoading(false);
  };

  // 📥 DOWNLOAD PDF
  const downloadPDF = () => {
    if (!pdf) {
      alert("PDF not available");
      return;
    }

    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdf}`;
    link.download = `${rcno}.pdf`;
    link.click();
  };

  return (
    <div className="rcpro-container">
      <h2 className="title">🚗 RC PRO SEARCH 100/-</h2>

      {/* 🔎 INPUT BOX */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Enter RC Number (e.g. DL01AB1234)"
          value={rcno}
          onChange={(e) => setRcno(e.target.value.toUpperCase())}
        />

        <button onClick={searchRC} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {/* ❌ ERROR */}
      {error && <p className="error">{error}</p>}

      {/* 📊 DATA TABLE */}
      {data && (
        <div className="result-box">
          <h3>RC Details</h3>

          <table>
            <tbody>
              {Object.entries(data).map(([key, value]) => (
                <tr key={key}>
                  <td className="key">{key}</td>
                  <td className="value">
                    {value ? value.toString() : "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* 📥 DOWNLOAD BUTTON */}
          <button className="download-btn" onClick={downloadPDF}>
            ⬇ Download PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default RCPro;